// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const musharna: PokeData = {
  "id": 518,
  "name": "musharna",
  "height": 11,
  "weight": 605,
  "base_experience": 170,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "psychic",
    "hypnosis",
    "defense-curl",
    "dream-eater",
    "moonlight",
    "future-sight",
    "magic-coat",
    "yawn",
    "imprison",
    "calm-mind",
    "lucky-chant",
    "zen-headbutt",
    "wonder-room",
    "stored-power",
    "moonblast",
    "psychic-terrain"
  ],
  "moves": [
    "psychic",
    "moonlight",
    "future-sight",
    "calm-mind",
    "zen-headbutt",
    "moonblast",
    "psychic-terrain",
    "psy-ball",
    "psy-pulse",
    "psywave",
    "kinesis",
    "synchronize",
    "reflect"
  ],
  "evolution_chain": {
    "id": 265,
    "item": null,
    "species": [
      {
        "name": "munna",
        "order": 518,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "musharna",
        "order": 519,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 517,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 172,
    "speed": 49,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
